import { ExclamationBrown } from '@icons';
import React, { ReactNode } from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';

interface ConfirmModalProps extends ModalProps {
	title: ReactNode;
	message: ReactNode;
	show: boolean;
	onHide: () => void;
	callback: () => void;
	confirmButtonLabel: ReactNode;
	confirmButtonClassName?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	title,
	message,
	show,
	onHide,
	callback,
	confirmButtonLabel,
	confirmButtonClassName = 'custom-primary-button',
	...props
}) => {
	return (
		<Modal
			show={show}
			onHide={() => {
				onHide();
			}}
			centered
			className="supermodal"
			backdropClassName="supermodal-backdrop"
			{...props}
		>
			<Modal.Header
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '16px',
					padding: '22px',
				}}
			>
				<ExclamationBrown style={{ margin: '8px', width: '40px', height: '40px', fill: 'var(--np-orange)' }} />
				<h3
					style={{
						fontSize: '24px',
						textAlign: 'center',
						lineHeight: '28px',
						marginBottom: 0,
						fontWeight: 700,
					}}
				>
					{title}
				</h3>
			</Modal.Header>
			<Modal.Body
				style={{
					padding: '0 22px',
				}}
			>
				<div
					style={{
						textAlign: 'center',
						marginBottom: 0,
						lineHeight: '28px',
					}}
				>
					{message}
				</div>
			</Modal.Body>
			<Modal.Footer style={{ display: 'flex', padding: '22px', paddingTop: 0, flexWrap: 'nowrap', marginTop: '48px' }}>
				<Button
					className="btn custom-outline-button"
					style={{
						width: '100%',
						height: '48px',
					}}
					onClick={() => {
						onHide();
					}}
				>
					Annulla
				</Button>
				<Button
					className={`btn ${confirmButtonClassName}`.trim()}
					style={{
						width: '100%',
						height: '48px',
					}}
					onClick={() => {
						callback();
						onHide();
					}}
				>
					{confirmButtonLabel}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmModal;
